import type { IEntityResponse } from '../response'

export enum BabyGender {
  MALE = 'Male',
  FEMALE = 'Female',
}

interface IBaby {
  id: number
  name: string
  birthDate: string
  gender: BabyGender
  avatar: string
}

interface IBabyLastEvents {
  lastFeedingSeconds: number
  lastSleepSeconds: string
}

interface IBabySettings {
  gender: BabyGender
  name: string
  birthDate: string
  feedNotification: {
    hours: string | number
    minutes: string | number
  }
  sleepNotification: {
    hours: string | number
    minutes: string | number
  }
}

type BabyResponse = IEntityResponse<IBaby>
type BabyLastEventsResponse = IEntityResponse<IBabyLastEvents>

export type { IBaby, IBabySettings, IBabyLastEvents, BabyResponse, BabyLastEventsResponse }
